// The server snippet arrives indented inside a Ruby heredoc. Targets that
// prepend column-zero comment lines must de-indent the block themselves,
// since a common-indent scrub over the combined string would see a
// zero-width indent and leave the script body ragged.
export default code => {
  const lines = code.replace(/^\n+|\s+$/g, '').split('\n');
  const indent = Math.min(
    ...lines.filter(line => line.trim()).map(line => line.search(/\S/))
  );
  return lines.map(line => line.slice(indent)).join('\n');
};
